"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index = 0;
exports.generateID = function () {
    return (index += 1);
};
//# sourceMappingURL=uid.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-mapbox-gl/lib/util/uid.js
// module id = 127
// module chunks = 1135276415346 35783957827783 89888082226891